// extracted by mini-css-extract-plugin
module.exports = {"section":"ContentArea_section__UQuOs","content":"ContentArea_content__2W3TL"};